// extracted by css-extract-rspack-plugin
export default {"input":"borderless__input___U6fzJ common__bottomBorder___xG8Vq","withPrefix":"borderless__withPrefix___rCbJO","prefixLabel":"borderless__prefixLabel___EwWqN"};